import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import '@veneer/styles/typography/typography.css'

import { mfePreset } from './mfe-preset'

import { useInitApp } from '@/hooks/useInitApp'
import { UnrecoverableErrorPage } from '@/pages/UnrecoverableError'
import { AppProps } from '@/types/app-props'
import { DependencyManagerProvider } from '@foreign-clientos/dependency-manager'

mfePreset()

export function createRootComponent(
  bundleName: string,
  EntryComponent: React.FC<AppProps>,
) {
  return function RootComponent(props: AppProps) {
    const initialized = useInitApp(props)

    return (
      initialized && (
        <DependencyManagerProvider bundleName={bundleName}>
          <ErrorBoundary FallbackComponent={UnrecoverableErrorPage}>
            <EntryComponent {...props} />
          </ErrorBoundary>
        </DependencyManagerProvider>
      )
    )
  }
}
